<template>
  <div class="teasers">
    <template v-for="teaser in teasers">
      <v-teaser :key="teaser.id" :teaser="teaser"/>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'teasers',
    data() {
      return {};
    },
    props: {
      teasers: {
        type: Array,
      },
    },
    methods: {},
    components: {
      vTeaser: () => import('@/components/teaser'),
    },
  };
</script>
